import React from 'react';
import WorkspaceAuroraBackground from '../layout/WorkspaceAuroraBackground';

const PageLoader: React.FC = () => {
  return (
    <div className="min-h-screen relative overflow-hidden bg-gray-50">
      <WorkspaceAuroraBackground />
      <div className="relative z-10 mx-auto max-w-5xl px-6 py-12">
        <div className="animate-pulse space-y-6">
          <div className="h-10 w-56 rounded-lg bg-white/80 border border-gray-200" />
          <div className="h-5 w-80 rounded bg-white/70 border border-gray-100" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
            <div className="h-28 rounded-xl bg-white/80 border border-gray-200" />
            <div className="h-28 rounded-xl bg-white/80 border border-gray-200" />
            <div className="h-28 rounded-xl bg-white/80 border border-gray-200" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-6">
            <div className="h-52 rounded-xl bg-white/80 border border-gray-200" />
            <div className="h-52 rounded-xl bg-white/80 border border-gray-200" />
            <div className="h-52 rounded-xl bg-white/80 border border-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
